var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.vueFormRerender
    ? _c("Vueform", {
        ref: "vueform",
        attrs: { schema: _vm.vueFormSchema, sync: "" },
        model: {
          value: _vm.vueFormData,
          callback: function($$v) {
            _vm.vueFormData = $$v
          },
          expression: "vueFormData"
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }